import React from 'react'
import { useIntl } from 'react-intl'
import {
    StyledBackground,
    StyledButtonContainer,
    StyledMainContainer
} from './styles'
import { Spacer } from 'app-v2/design-systems/components/Spacer/Spacer'
import { SIZE } from 'app-v2/design-tokens'
import { NoDesktopCard } from './components'
import { PrimaryButton } from 'app-v2/design-systems'
import { Layout } from 'app/ecommerce/common'
import { useHistory } from 'react-router-dom'

export const KingTableNoDesktopScreen = () => {
    const intl = useIntl()
    const history = useHistory()
    return (
        <Layout background="plain" border showLogoBK closeEnabled>
            <StyledMainContainer>
                <StyledBackground>
                    <Spacer size={SIZE.XXL} />
                    <NoDesktopCard />
                </StyledBackground>
                <StyledButtonContainer>
                    <PrimaryButton onClick={() => history.goBack()}>
                        {intl.formatMessage({ id: 'goback' })}
                    </PrimaryButton>
                </StyledButtonContainer>
            </StyledMainContainer>
        </Layout>
    )
}
